import React, { useState, useRef } from "react";

import { Button, CircularProgress, TextField, Typography } from "@mui/material";
import { BlockStandard } from "components/admin/BlockStandard";
import { PageStandard } from "components/admin/PageStandard";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ptBR } from "date-fns/locale";
import {
  updateInstallationDate,
  updateInvestmentData,
} from "libLegacy/api/dashboard";
import { useToken } from "contexts/UserContext";
import { useSetError } from "contexts/ErrorContext";
import { CustomCodes } from "contexts/ErrorContextData";

export const InvestmentsEdit = ({ location, history }) => {
  const token = useToken();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [investedAmount, setInvestedAmount] = useState<string>(
    location.state?.investedAmount
      ? (+location.state?.investedAmount).toLocaleString("pt-br")
      : ""
  );
  const [expectedEconomy, setExpectedEconomy] = useState<string>(
    location.state?.expectedEconomy
      ? (+location.state?.expectedEconomy).toLocaleString("pt-br")
      : ""
  );
  const [averageBill, setAverageBill] = useState<string>("");
  const dateInputRef = useRef<HTMLInputElement>(null);
  const defaultInstallDate = location.state?.instalationDate
    ? new Date(location.state.instalationDate)
    : new Date();
  const setGlobalError = useSetError();

  const handleSubmit = async () => {
    const installationDate = dateInputRef.current?.value;
    if (investedAmount && expectedEconomy && installationDate) {
      setIsLoading(true);
      const formattedDate = installationDate?.split("/").reverse().join("-");
      try {
        await updateInvestmentData(
          token,
          +expectedEconomy.replace(/\./g, "").replace(/,/g, "."),
          +investedAmount.replace(/\./g, "").replace(/,/g, ".")
        );
        await updateInstallationDate(token, formattedDate);
        history.goBack();
      } catch (error) {
        // @ts-expect-error
        setGlobalError(error.response?.data?.error);
      } finally {
        setIsLoading(false);
      }
    } else {
      setGlobalError(CustomCodes.INVALID_FORM);
    }
  };

  return (
    <PageStandard title="Investimentos">
      <BlockStandard hideDivider>
        <Typography variant="h3">
          Você ainda não possui dados de investimento.
        </Typography>
      </BlockStandard>
      <BlockStandard hideDivider>
        <img
          alt=""
          src="/static/img/investments-edit.png"
          style={{ height: "150px", objectFit: "contain" }}
        />
      </BlockStandard>
      <BlockStandard hideDivider>
        <Typography variant="h3">
          Basta nos informar os seguintes dados do seu investimento, que o
          restante é comigo.
        </Typography>
        <TextField
          value={investedAmount}
          onChange={({ target }) => setInvestedAmount(target.value)}
          label="Investimento total em R$"
        />
      </BlockStandard>

      <BlockStandard hideDivider>
        <Typography variant="h3">
          Informe a data de instalação do sistema solar{" "}
        </Typography>
        <LocalizationProvider
          dateAdapter={AdapterDateFns}
          localeText={{
            cancelButtonLabel: "Cancelar",
            okButtonLabel: "Salvar",
          }}
          adapterLocale={ptBR}
        >
          <MobileDatePicker
            label="Data de instalação"
            inputRef={dateInputRef}
            format="dd/MM/yyyy"
            defaultValue={defaultInstallDate}
            disableFuture
            closeOnSelect
          />
        </LocalizationProvider>
      </BlockStandard>

      <BlockStandard hideDivider>
        <Typography variant="h3">
          Quanto você espera economizar mensalmente na sua conta de luz?
        </Typography>
        <TextField
          label="Economia mensal esperada em R$"
          value={expectedEconomy}
          onChange={({ target }) => setExpectedEconomy(target.value)}
        />
      </BlockStandard>

      <BlockStandard hideDivider>
        <Typography variant="h3">
          Qual era o valor da sua fatura antes da instalação do seu sistema
          solar?
        </Typography>
        <TextField
          label="Valor da conta de luz em R$"
          value={averageBill}
          onChange={({ target }) => setAverageBill(target.value)}
        />
      </BlockStandard>

      <BlockStandard hideDivider>
        <Button variant="contained" onClick={handleSubmit} disabled={isLoading}>
          {isLoading ? <CircularProgress /> : "Continuar"}
        </Button>
      </BlockStandard>
    </PageStandard>
  );
};
